import React, { MouseEventHandler } from 'react'

interface ButtonProps {
  label: string
  action: MouseEventHandler<HTMLButtonElement>
  color?: string
  className?: string
}

export default function Button(props: ButtonProps): JSX.Element {
  const { label, action, color, className } = props
  const colorMap = {
    red: 'text-white bg-red-100 hover:bg-red-300',
    gray: 'text-white bg-gray-700 hover:bg-gray-300',
    white: 'text-black bg-white hover:bg-white/80',
    black: 'text-white bg-black hover:bg-black/80',
    instagram:
      'text-white bg-gradient-to-r from-fuchsia-600 via-rose-500 to-amber-400 hover:from-fuchsia-500 hover:via-rose-400 hover:to-amber-300',
  }

  return (
    <button
      type="button"
      className={`${
        colorMap[color as keyof typeof colorMap] || colorMap.red
      } focus:outline-none font-medium rounded-full w-full sm:w-auto px-10 py-3.5 text-center transition-all duration-300 ease-in-out display-inline-block cursor-pointer shadow-lg hover:shadow-xl ${className}`}
      onClick={action}
    >
      {label}
    </button>
  )
}
